import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types';
import OfferDecryptionProgress from "../components/OfferDecryptionProgress";
import {makeStyles} from "@material-ui/core";
import RfxOfferService from "services/RfxOfferService";
import {connect} from "react-redux";
import Loading from "components/Loading";
import {withRouter} from "react-router";
import PublicSessionOnlineProgress from "../components/PublicSessionOnlineProgress";
import DealingsService from "services/DealingsService";
import RealizationAmountProgress from "../components/RealizationAmountProgress";
import {isDemandOfferCollection, isDemandOfferDecryption, isDemandModification} from "libs/getDemandStatus";
import moment from "libs/moment";

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(4)
    }
}));

function OfferDecryptionSection(
    {
        demandStatistics,
        currentRfxRound,
        match,
        rfxOfferDecryptionStatus,
        onlineSessionStatus,
        dealingsRealizationValueStatus,
        demandHeader
    }) {

    const classes = useStyle();
    const demandId = match.params.id;
    const isOfferCollection = isDemandOfferCollection();
    const isModification = isDemandModification();
    const isOfferDecryption = isDemandOfferDecryption();
    const offerOpenTimeout = useRef(null);

    useEffect(() => {
        clearTimeout(offerOpenTimeout.current);
        if (currentRfxRound) {
            const offerOpenDate = moment(currentRfxRound.offerOpenDate);
            const offerDeadline = moment(currentRfxRound.offerEndDate);
            const now = moment(currentRfxRound.now);
            if (offerOpenDate.isAfter(now) && offerOpenDate.isAfter(offerDeadline)) {
                const diff = offerOpenDate.diff(now) + 500;
                offerOpenTimeout.current = setTimeout(() => {
                    RfxOfferService.getOffersDecryptionStatus(currentRfxRound.id);
                }, diff);
            }
        }

        return () => {
            if (offerOpenTimeout.current) clearTimeout(offerOpenTimeout.current);
        }
    }, [demandStatistics, currentRfxRound])


    useEffect(() => {

        if (currentRfxRound) {
            RfxOfferService.getOffersPublicSessionOnlineStatus(currentRfxRound.id);
            RfxOfferService.getOffersDecryptionStatus(currentRfxRound.id);
            if (demandHeader && !demandHeader.passiveOfferForm) {
                DealingsService.getRealizationValueStatus(demandId);
            }
        }

        return () => {
            RfxOfferService.clearResources(RfxOfferService.RESOURCE_ID_RFX_PUBLIC_SESSION_ONLINE_STATUS);
            RfxOfferService.clearResources(RfxOfferService.RESOURCE_ID_RFX_OFFER_DECRYPTION_STATUS);
            DealingsService.clearResources(DealingsService.RESOURCE_DEALING_REALIZATION_VALUE_STATUS);
        }
    }, [currentRfxRound, demandId, isOfferCollection, isOfferDecryption, demandHeader]);


    if (!demandStatistics || !onlineSessionStatus || !rfxOfferDecryptionStatus || !currentRfxRound || !demandHeader || (!demandHeader.passiveOfferForm && isOfferCollection && !dealingsRealizationValueStatus)) {
        return <Loading/>;
    }

    return (
        <div className={classes.root}>
            {(isOfferCollection || isModification) &&
            <PublicSessionOnlineProgress demandId={demandId} roundId={currentRfxRound.id}/>}
            {(!demandHeader.passiveOfferForm && Boolean(dealingsRealizationValueStatus)) &&
            <RealizationAmountProgress demandHeader={demandHeader} demandStatistics={demandStatistics} demandId={demandId} roundId={currentRfxRound.id}/>}
            {((isOfferCollection || isModification || isOfferDecryption)) && currentRfxRound.offerCollectionEnded && <OfferDecryptionProgress demandId={demandId} roundId={currentRfxRound.id}/>}
        </div>
    )
}


OfferDecryptionSection.propTypes = {
    demandStatistics: PropTypes.object
}

const mapStateToProps = state => {
    return {
        rfxOfferDecryptionStatus: state.resources[RfxOfferService.RESOURCE_ID_RFX_OFFER_DECRYPTION_STATUS],
        onlineSessionStatus: state.resources[RfxOfferService.RESOURCE_ID_RFX_PUBLIC_SESSION_ONLINE_STATUS],
        dealingsRealizationValueStatus: state.resources[DealingsService.RESOURCE_DEALING_REALIZATION_VALUE_STATUS],
        demandHeader: state.resources.demandHeader,
        //rfxOfferPublicSessionStatus: state.resources[RfxOfferService.RESOURCE_ID_RFX_OFFER_PUBLIC_SESSION_STATUS],
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OfferDecryptionSection));
